<template>
  <v-app>
    <app-bar
      v-model="appBarCollapsed"
      :researcher="researcher"
      @logout="authService.logout()"
    />
    <v-main>
      <div class="click-container" @click="appBarCollapsed = true">
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar';
import { getInstance } from '@/auth/authWrapper';
import { Researcher } from '@/models';
import { GetCurrentResearcher } from '@/graphql';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    AppBar,
  },
  data: () => ({
    authService: null,
    researcher: null,
    appBarCollapsed: true,
  }),
  apollo: {
    researcher: {
      query: GetCurrentResearcher,
      update: (data) => new Researcher(data.currentResearcher),
      skip() {
        return (
          this.authService === null ||
          !this.authService.isAuthenticated
        );
      },
    },
  },
  computed: {
    ...mapGetters({
      uploadsInProgress: 'upload/uploadsInProgress',
    }),
  },
  mounted() {
    this.authService = getInstance();
    this.preventTabCloseOnInProgressUploads();
  },
  methods: {
    preventTabCloseOnInProgressUploads() {
      window.addEventListener('beforeunload', (event) => {
        if (this.uploadsInProgress) {
          event.preventDefault();
          event.returnValue = '';
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.click-container {
  height: 100%;
}
</style>
